<template>
  <div>
    <h1>Home</h1>
    <button @click="goToBefore" class="btn btn-success">跳转到上一次页面</button>
    <button @click="goToMenu" class="btn btn-success">跳转到指定menu</button>
    <button @click="goToRouterName" class="btn btn-success">跳转到指定路由的名字下</button>
    <button @click="pushMenu" class="btn btn-success">push跳转</button>

  </div>
</template>

<script>
  export default {
  methods:{
    goToBefore(){
      //跳转到上一次浏览的页面
      this.$router.go(-1);
    },
    //指定跳转的地址
    goToMenu(){
      this.$router.replace("/menu");
    },
    //指定跳转路由的名字下
    goToRouterName(){
      this.$router.replace({name:'menulink'});
    },
    //通过push进行跳转
    pushMenu(){
      // this.$router.push('/menu');
      this.$router.push({name:'menulink'});
    }

  }
  }
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/Home.vue